var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95828 9.39753C4.85785 9.39753 4.76437 9.38151 4.67784 9.34945C4.5913 9.31741 4.50904 9.26239 4.43105 9.18439L0.951883 5.70524C0.831161 5.58452 0.772932 5.43602 0.777196 5.25974C0.781474 5.08346 0.843974 4.93496 0.964696 4.81424C1.08542 4.69351 1.23179 4.63314 1.4038 4.63314C1.5758 4.63314 1.72216 4.69351 1.84288 4.81424L4.95828 7.92962L12.157 0.730909C12.2777 0.610173 12.4262 0.549805 12.6025 0.549805C12.7788 0.549805 12.9273 0.610173 13.048 0.730909C13.1687 0.851631 13.2291 1.00013 13.2291 1.17641C13.2291 1.35269 13.1687 1.50119 13.048 1.62191L5.48551 9.18439C5.40752 9.26239 5.32526 9.31741 5.23872 9.34945C5.15219 9.38151 5.05871 9.39753 4.95828 9.39753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.993f11b786cf6d0b1c53da368fe58987.svg";
export { ForwardRef as ReactComponent };